/**
 * Bridge between the service worker registration (services/pwa.ts, loaded
 * only by main.tsx) and the in-app "new version" prompt, so components and
 * tests never import the virtual PWA module.
 */

type UpdateHandler = () => Promise<void>;

let applyUpdate: UpdateHandler | null = null;

export function setAppUpdateHandler(handler: UpdateHandler): void {
  applyUpdate = handler;
}

/** Activate the waiting service worker and reload into the new build. */
export function applyAppUpdate(): void {
  if (applyUpdate) {
    void applyUpdate();
  } else {
    window.location.reload();
  }
}
